<template>
  <div class="reference-container">
    <base-loading-state v-if="isLoading" />
    <div v-else-if="learningUnit.reference" class="reference-content">
      <h3 class="mb-4 text__topic-title">Reference</h3>

      <base-text-editor-display>
        <div v-safe-html="learningUnit.reference" class="reference-text text__topic-content"></div>
      </base-text-editor-display>
    </div>
    <div v-else class="no-content">No references available</div>
  </div>
</template>

<script>
import MethodComponent from '@/models/MethodComponent';
import BaseTextEditorDisplay from '@/components/base-components/BaseTextEditorDisplay';
import LearningUnit from '@/models/LearningUnit';
import BaseLoadingState from '@/components/base-components/BaseLoadingState';

export default {
  name: 'PageReference',

  components: {
    BaseLoadingState,
    BaseTextEditorDisplay
  },

  data() {
    return {
      isLoading: true
    };
  },

  computed: {
    learningUnitId() {
      return Number.parseInt(this.$route.params.learningUnitId);
    },

    learningUnit() {
      return LearningUnit.find(this.learningUnitId);
    }
  },

  async created() {
    try {
      this.isLoading = true;
      await this.fetchData();
    } catch (error) {
      console.error('Error fetching references:', error);
      this.$toast?.('Failed to load references');
    } finally {
      this.isLoading = false;
    }
  },

  methods: {
    async fetchData() {
      await MethodComponent.api().fetch({
        learning_unit: this.learningUnitId
      });
    }
  }
};
</script>

<style lang="scss">
.reference-container {
  padding: 1.5rem;
  background-color: white;

  .reference-content {
    margin: auto;
    max-width: 960px;
  }

  .text__topic-title {
    font-size: 27px;
    font-weight: 700;
  }

  .text__topic-content {
    line-height: 1.6;
  }

  .no-content {
    text-align: center;
    color: #6c757d;
    padding: 2rem;
  }
}
</style>
